/**
 * Il posto, nell'intestazione della shell, dove il banco scrive la sua fascia
 * di stato (GI-266).
 *
 * **Una riga di testa sola.** Prima erano due: l'intestazione della shell —
 * titolo, «Torna al pool», identita', rete, lingua — e sotto la fascia del
 * banco — commessa, uscite, Coda/Foto, conteggi, gettoni vivi. Due righe di
 * cromo mezze vuote sopra un fotogramma che si guarda per ore. La shell offre
 * qui un nodo; il banco ci monta la sua fascia con un portale, e quando non
 * c'e' nessuna shell — nelle prove, o montato da solo — la disegna al suo
 * posto, in cima alla griglia. Cosi' la shell non deve sapere della sessione
 * e il banco non deve sapere di chi e' connesso.
 */
import { createContext, useContext } from 'react'

export const HeadSlot = createContext<HTMLElement | null>(null)

/** Il nodo dell'intestazione in cui montare la fascia, o nulla se non c'e'
 *  una shell attorno. */
export function useHeadSlot(): HTMLElement | null {
  return useContext(HeadSlot)
}
